import { render } from "./AtomServiceBadge.vue?vue&type=template&id=a4999d50&scoped=true&ts=true"
import script from "./AtomServiceBadge.vue?vue&type=script&lang=ts"
export * from "./AtomServiceBadge.vue?vue&type=script&lang=ts"

import "./AtomServiceBadge.vue?vue&type=style&index=0&id=a4999d50&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4999d50"]])

export default __exports__